// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__TuyGN","info":"Note_info__14RAv","note":"Note_note__2SKx1","actions":"Note_actions__3cP9Q"};